const info = theme => ({
  backgroundColor: theme.tokens.ComponentFlagVariantInfoBg
});
const error = theme => ({
  backgroundColor: theme.tokens.ComponentFlagVariantErrorBg
});
const success = theme => ({
  backgroundColor: theme.tokens.ComponentFlagVariantSuccessBg
});
const caution = theme => ({
  backgroundColor: theme.tokens.ComponentFlagVariantCautionBg
});
const white = theme => ({
  backgroundColor: theme.tokens.ComponentFlagVariantWhiteBg
});
const light = theme => ({
  backgroundColor: theme.tokens.ComponentFlagVariantLightBg
});
const dark = theme => ({
  backgroundColor: theme.tokens.ComponentFlagVariantDarkBg,
  color: theme.tokens.ComponentFlagVariantDarkColor
});
const getColorStyle = (flagVariant, theme) => {
  switch (flagVariant) {
    case 'info':
      {
        return info(theme);
      }
    case 'error':
      {
        return error(theme);
      }
    case 'success':
      {
        return success(theme);
      }
    case 'caution':
      {
        return caution(theme);
      }
    case 'white':
      {
        return white(theme);
      }
    case 'light':
      {
        return light(theme);
      }
    case 'dark':
      {
        return dark(theme);
      }
    default:
      {
        return light(theme);
      }
  }
};
const flagStyleDecorator = (flagVariant, style, theme) => {
  return {
    ...style,
    ...getColorStyle(flagVariant, theme)
  };
};
export default flagStyleDecorator;